import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "AnnotationVisibility"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 3H3C2.17157 3 1.5 3.67157 1.5 4.5V19.5C1.5 20.3284 2.17157 21 3 21H21C21.8284 21 22.5 20.3284 22.5 19.5V4.5C22.5 3.67157 21.8284 3 21 3ZM14.2499 6H19.4999V7.5H14.2499V6ZM9.74991 15H15.7499V16.5H9.48741C8.9295 17.6762 7.59387 18.2658 6.34888 17.8855C5.10389 17.5052 4.32567 16.2699 4.52017 14.9828C4.71468 13.6956 5.82314 12.7454 7.12491 12.75C7.35295 12.7492 7.58004 12.7795 7.79991 12.84L10.6349 7.875L11.9399 8.625L9.08991 13.605C9.44433 13.9936 9.67421 14.4795 9.74991 15ZM5.99988 15.375C5.99988 15.9963 6.50356 16.5 7.12488 16.5C7.7462 16.5 8.24988 15.9963 8.24988 15.375C8.24988 14.7537 7.7462 14.25 7.12488 14.25C6.50356 14.25 5.99988 14.7537 5.99988 15.375ZM17.2499 9H14.2499V10.5H17.2499V9ZM3 19.5H21V4.5H3V19.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/AnnotationVisibility.vue"]]);
